<template>
  <div class="item-base">
    <div class="itembody">
      <item-heading
        class="item-heading"
        :title="itemDataMod.name"
        :is-small="!!itemDataMod.isSmall"
        :user-id="+userProfile.id"
        :item-data="itemDataMod"
      />
      <template v-if="hasTags">
        <div class="menu-tags" v-if="tags.length > 0">
          <span class="tag-icon"><img src="/static/img/icons/ic_tag.svg"></span>
          <tag-list :tag-list="tags" :link-enable="false" />
        </div>
      </template>
      <div class="itemfoot">
        <div class="closed-message">配信終了しました</div>
      </div>
    </div>
    <transition>
      <div class="loader" v-if="!loadComplete"></div>
    </transition>
  </div>
</template>

<script>
import TagList from "@/utvStore/components/partials/TagList";
import ItemHeading from "@/utvStore/components/partials/ItemHeading";
export default {
  name: "PlaylistItem",
  components: {ItemHeading, TagList, },
  data(){
    return {
      loadComplete: false,
      isCThumbError: false,
      itemDataMod: {},
    }
  },
  props: {
    allLock: {
      type: Boolean,
      default: false,
    },
    itemData: {
      type: Object,
      default() {
        return {}
      }
    },
    userProfile: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  watch: {
    itemData: {
      handler(val){
        this.setItemData()
      },
      deep: true
    },
  },
  computed: {
    hasTags(){
      return this.itemDataMod ? !!this.itemDataMod.tags : false
    },
    tags() {
      const rtn = []
      if(!!this.itemDataMod && !!this.itemDataMod.tags ){
        this.itemDataMod.tags.forEach(val=>{
          if(!/^_/.test(val.tagName)){
            rtn.push({ ...val, label: val.tagName })
          }
        })
      }
      return rtn
    },
  },
  created() {
    this.setItemData()
  },
  mounted() {
    this.loadComplete = true
  },
  methods: {
    setItemData (){
      this.itemDataMod = this.itemData
    },
  },
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.item-base {
  width: 100%;
  min-height: 80px;
  padding: 25px 20px;
  border-bottom: 1px solid $col_temp_gray3;
  position: relative;
  color: $col_dark_font;
  .itembody {
    .thumbnail {
      $largeSize: 85px;
      width: $largeSize;
      height: $largeSize;
      border-radius: $largeSize / 2;
      margin-right: 16px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
  }
  .itemfoot {
    text-align: right;
    line-height: 1;
    margin-right: -6px;
    display: flex;
    justify-content: center;
    .closed-message {
      display: inline-block;
      font-size: 14px;
      font-weight: bold;
      line-height: 1;
      color: $col_temp_key1;
      background: #fff5f8;
      border-radius: 7px;
      padding: 10px 24px;
    }
  }
}

.loader {
  width: 100%;
  height: 100%;
  background: url('/static/img/common/loading.svg') no-repeat center center rgba(255,255,255,0.9);
  background-size: 12vw 12vw;
  position: absolute;
  top: 0;
  left: 0;
}
.menu-tags {
  display: block;
  padding-left: 18px;
  position: relative;
  margin-bottom: 14px;
  .tag-icon {
    display: inline-block;
    position: absolute;
    top: 3px;
    left: 0;
    width: 13px;
    img {
      display: block;
      width: 100%;
    }
  }
  /deep/ .tag-list-base {
    color: $col_normal_font;
  }
}


.v-enter-active,
.v-leave-active {
  transition: all 200ms ease-out 0s;
}

.v-enter, .v-leave-to {
  opacity: 0;
}

.v-enter-to, .v-leave {
  opacity: 1;
}
</style>

<style lang="scss">
.item-base .tag-list-base li {
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Playlist/ClosedItem.vue